import styles from "./styles.module.scss";
import { Button, Input } from "components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { Link } from "react-router-dom";
import { Routes } from "router";
import { useState } from "react";
import { EnvelopeIcon, PrecisionLogoMain } from "assets";

interface SigninData {
  email: string;
  password: string;
}

const initSignup: SigninData = {
  email: "",
  password: "",
};

const schema = yup.object({
  email: yup.string().email("Enter a valid email").required("Required"),
  password: yup.string().required("Required"),
});

interface SigninProps {
  handleForgot: () => void;
  sumbit: (data: SigninData) => void;
}

const SigninUI: React.FC<SigninProps> = ({ handleForgot, sumbit }) => {
  const [remember, setRemember] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<SigninData>({
    resolver: yupResolver(schema),
    mode: "onTouched",
    defaultValues: initSignup,
  });

  const onSubmit: SubmitHandler<SigninData> = (data) => {
    sumbit({ ...data, email: data.email.toLowerCase().trim() });
  };

  const handleRemember = () => {
    setRemember((prev) => {
      const next = !prev;
      if (next) localStorage.setItem("precisionRememberMe", "true");
      else localStorage.removeItem("precisionRememberMe");
      return next;
    });
  };

  return (
    <div className="">
      <div className="bg-[#26279A] h-[260px] pt-[40px] px-8 lg:hidden flex flex-col items-center">
        <Link to={Routes.home} className="w-fit">
          <PrecisionLogoMain className='w-[180px] flex-shrink-0' />
        </Link>
        <h1 className='text-[23px] font-bold mt-5 text-white w-fit lg:hidden flex'>Welcome Back</h1>
      </div>
      <div className="lg:w-full w-[90%] mx-auto lg:mt-0 -mt-[80px] rounded-xl lg:p-0 p-4 bg-[#E8F3FF] sm:mb-0 mb-8">
        <h1 className='text-[27px] font-bold mt-9 text-[#012169] w-fit mx-auto lg:block hidden'>Welcome Back</h1>
        <form className='lg:mt-7' noValidate>
          <Input
            label="Email"
            placeholder="email@example.com"
            type="email"
            required
            validatorMessage={errors.email?.message}
            name="email"
            register={register}
            value={watch("email")}
            parentClassName="[&>label]:text-[#344054] [&>label]:font-light !mb-2"
            Icon={EnvelopeIcon}
            iconClassName="!w-4.5 !h-4.5 left-4 !top-11"
            className="!pl-11 !bg-white !border-[#EAECF0] !shadow-none"
          />
          <Input
            label="Password"
            placeholder="Enter password"
            type="password"
            required
            validatorMessage={errors.password?.message}
            name="password"
            register={register}
            value={watch("password")}
            parentClassName="[&>label]:text-[#344054] [&>label]:font-light"
            className=" !bg-white !border-[#EAECF0] !shadow-none"
            iconClassName="!w-4 !h-4 !top-11"
          />
          <div className={styles.otherInfo}>
            <label className="!text-[#566B9B] !text-xs relative inline-flex items-center">
              <input
                type="checkbox"
                checked={remember}
                onChange={handleRemember}
                className="
      peer mr-2 w-3.5 h-3.5 appearance-none rounded-[3px] border border-[#566B9B] 
      checked:bg-transparent cursor-pointer"
              />
              <span
                className="pointer-events-none absolute left-[5.5px] top-[2px] w-[5px] h-[9px] rotate-45 border-r-2 border-b-2 border-[#012169] opacity-0 peer-checked:opacity-100"
              />
              Remember me
            </label>

            <Link to={Routes.forgotPassword} className="!text-[#012169]">Forgot Password?</Link>
          </div>
          <Button
            type="fill"
            onClick={handleSubmit(onSubmit)}
            className='!bg-[#012169] !border-none w-full text-white !hover:bg-[#012169] !hover:opacity-60 mt-6 mb-3 !py-3 !text-base !rounded-[5px]'
          >
            Sign in
          </Button>
        </form>
        <p className='text-[#2B4682] mx-auto w-fit pt-1 pb-8'>
          New to Precision? <Link to={Routes.signup} className="text-[#012169] font-semibold">Sign up</Link>
        </p>
      </div>

    </div>
  );
};

export { SigninUI };
